import React from 'react';
import moment from 'moment';
import TextTruncate from 'react-text-truncate';
import { ShowIf } from 'components/utils';
import { CheckQuyenThaoTacXuLy } from 'modules/login/CheckQuyenThaoTacXuLy';
import { isEmpty, get } from 'lodash';
import { TextMessage } from 'components/tt-forms/common';

class RowItemCapNhatNguoiDungXLD extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      trangThaiDonText: '',
      ketQuaStr: '',
      ketQuaType: ''
    }
  }

  componentDidMount() {
    if (!isEmpty(this.props.item.trangThaiDonInfo)) {
      const [ trangThaiData ] = this.props.item.trangThaiDonInfo;
      this.setState({
        ketQuaStr: trangThaiData.ketQuaType == 'DINH_CHI' ? 'Rút đơn' : trangThaiData.ketQuaStr,
        ketQuaType: trangThaiData.ketQuaType,
        trangThaiDonText: trangThaiData.trangThaiDonText,
        trangThaiDonType: trangThaiData.trangThaiDonType,
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.type && this.props.type != nextProps.type) {
      this.setState({
        type: nextProps.type
      })
    }
    if (!isEmpty(nextProps.item.trangThaiDonInfo)) {
      const [ trangThaiData ] = nextProps.item.trangThaiDonInfo;
      this.setState({
        ketQuaStr: trangThaiData.ketQuaType == 'DINH_CHI' ? 'Rút đơn' : trangThaiData.ketQuaStr,
        ketQuaType: trangThaiData.ketQuaType,
        trangThaiDonText: trangThaiData.trangThaiDonText,
        trangThaiDonType: trangThaiData.trangThaiDonType,
      })
    }
  }

  showThongTinCongDan() {
    let size = '';
    const { listNguoiDungDon } = this.props.item;
    if (!isEmpty(listNguoiDungDon)) {
      size = listNguoiDungDon.length;
    }
    if (!size) {
      return null;
    }
    return (
      <div>
        <li className="txt-bold">{get(listNguoiDungDon, '[0].hoVaTen')}</li>
        <li>{this.getLocal(get(listNguoiDungDon, '[0]'))}</li>
        <li>{get(listNguoiDungDon, '[0].soDienThoai')}</li>
      </div>
    );
  }

  getLocal(data) {
    let address = [];
    const checkAddressData = (addressData) => {
      if (!isEmpty(addressData)) {
        address.push(addressData);
      }
    }
    checkAddressData(get(data, 'diaChi'));
    checkAddressData(get(data, 'toThon'));
    checkAddressData(get(data, 'phuongXaCongDan.ten'));
    checkAddressData(get(data, 'quanHuyenCongDan.ten'));
    checkAddressData(get(data, 'tinhThanhCongDan.ten'));
    return address.join(", ");
  }

  checkNguonDon(type) {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    const { nguonDonInfo } = this.props.item;
    let result = ''
    if (!isEmpty(nguonDonInfo)) {
      let dataNguonDon = this.props.item.nguonDonInfo.filter(nguonDon => {
        return nguonDon.idDonVi == userInfo.donViId;
      });

      if (!isEmpty(dataNguonDon)) {
        switch (type) {
          case 'nguonDonText':
            result = get(dataNguonDon, '[0].nguonDonText', '')
            return result;
          case 'nguonDonDonVi':
            result = get(dataNguonDon, '[0].donViChuyenText', '')
            return result;
          default: 
            return result;
        }
      }
    }
    return result;
  }

  checkDonViTTXM() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    if (get(this.props.item, 'donViThamTraXacMinhInfo.coQuanQuanLyId') === get(userInfo, 'donViId')) {
      return true
    } else {
      return false
    }
  }

  render() {
    let nguonDonText = this.checkNguonDon('nguonDonText');
    let nguonDonDonVi = this.checkNguonDon('nguonDonDonVi');
    const { soNguoi, ngayTiepNhan, loaiDonInfo, canBoDangXuLyInfo, ma, maHoSo  } = this.props.item;
    const donDate = ngayTiepNhan ? moment(ngayTiepNhan).format('DD/MM/YYYY') : '';
    const donTime = ngayTiepNhan ? moment(ngayTiepNhan).format('HH:mm') : '';
    return (
      <tr>
        <td className='table-checkbox'>
          <label className="pt-control pt-checkbox pt-large">
            <input
              type="checkbox"
              checked={this.props.item.selected || false}
              className="pt-large"
              onChange={this.props.parent.handleSelectedDoiTuong.bind(this.props.parent, this.props.item)}
              name="checkboxKetQua"
            />
            <span className="pt-control-indicator"></span>
          </label>
        </td>
        <td>{this.props.count}</td>
        <td>{ma || maHoSo}</td>
        <td>
          <ul className="list-items-table">
            <li>{donDate}</li>
            <li>{donTime}</li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            {this.showThongTinCongDan()}
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li>
              <ShowIf condition={!CheckQuyenThaoTacXuLy(canBoDangXuLyInfo)}>
                <TextTruncate
                  line={3}
                  truncateText="…"
                  text={this.props.item.noiDung}
                />
              </ShowIf>
            </li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li>
              {get(loaiDonInfo, 'ten', '')}
            </li>
            <li>{soNguoi ? (soNguoi + ' người') : ''}</li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <ShowIf condition={!isEmpty(nguonDonDonVi)}>
              <li className="txt-italic">{nguonDonDonVi}</li>
            </ShowIf>
            <li>{nguonDonText}</li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <ShowIf condition={this.state.trangThaiDonText != null && this.state.trangThaiDonText != ''}>
              <li>{this.state.trangThaiDonText}</li>
            </ShowIf>
            <ShowIf condition={this.state.ketQuaStr != null && this.state.ketQuaStr != ''}>
              <li>
                <TextMessage className='txt-italic col-100 no-gutter txt-left' value={this.state.ketQuaStr || ''}/>
              </li>
            </ShowIf>
          </ul>
        </td>

      </tr>
    )
  }
}

export default RowItemCapNhatNguoiDungXLD;



// WEBPACK FOOTER //
// ./src/components/modules/category/datatable/list/RowItemCapNhatNguoiDungXLD.jsx